import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;
const ImageSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    viewBox="0 0 32 32"
  >
    <g fill="none">
      <path
        fill="url(#SVG8GgFid6y)"
        d="M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5z"
      ></path>
      <path
        fill="url(#SVGW2xB2dVm)"
        d="M28.356 26.82A4.5 4.5 0 0 1 24.5 29h-17a4.5 4.5 0 0 1-3.856-2.18l10.588-10.588a2.5 2.5 0 0 1 3.536 0z"
      ></path>
      <path
        fill="url(#SVGWln7obLQ)"
        d="M19 11a3 3 0 1 1 6 0a3 3 0 0 1-6 0"
      ></path>
      <defs>
        <linearGradient
          id="SVGW2xB2dVm"
          x1={12.469}
          x2={15.605}
          y1={15.5}
          y2={29.673}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#b3e0ff"></stop>
          <stop offset={1} stopColor="#8cd0ff"></stop>
        </linearGradient>
        <linearGradient
          id="SVGWln7obLQ"
          x1={20.8}
          x2={22.992}
          y1={7.333}
          y2={15.225}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fdfdfd"></stop>
          <stop offset={1} stopColor="#b3e0ff"></stop>
        </linearGradient>
        <radialGradient
          id="SVG8GgFid6y"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(51.687 8.393 -13.26)scale(71.8942 65.3927)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.338} stopColor="#0fafff"></stop>
          <stop offset={0.529} stopColor="#367af2"></stop>
        </radialGradient>
      </defs>
    </g>
  </svg>
);
const ImageIcon = (props: CustomIconComponentProps) => (
  <Icon component={ImageSvg} {...props} />
);
export default ImageIcon;
